import React from 'react';
import {toJS} from 'mobx';
import {Card, CardActions, CardHeader, CardMedia, CardTitle, CardText} from 'material-ui/Card';
import FlatButton from 'material-ui/FlatButton';
import Toggle from 'material-ui/Toggle';
import TextField from 'material-ui/TextField';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import ScreenerToolBar from '../components/ScreenerToolBar';
import StrategyToolBar from '../components/StrategyToolBar';
import ContentAdd from 'material-ui/svg-icons/content/add';
import IconButton from 'material-ui/IconButton';
import {filter, cloneDeep, forOwn} from 'lodash';
import {debounce, percentageToNumber,numberToPercentage,isNumeric,isPercentage} from '../lib/utils'
import BuildApi from '../actions/BuildApi';
import BuildStore from '../store/BuildStore';
import Paper from 'material-ui/Paper';
import ImageNavigateNext from 'material-ui/svg-icons/image/navigate-next';
import HardwareKeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import FontIcon from 'material-ui/FontIcon';


var numeral = require('numeral');

const styles = {
	SectorCard:{
		margin:10,
		overflowX: 'hidden',
	},
	cardContentRow:{
	   	display: 'flex',
	    flexDirection: 'row wrap',
	    width:'98%',
	    marginLeft:'1%',
	    backgroundColor:'white',

	},
	input:{
		flex:1,
		// margin:10,
		fontFamily:'Roboto',
		fontSize: 10,
	    height:'30px',
	    fontWeight: 600,
		marginTop: '0.7%',
	},
	inputLabel:{
		flex:4,
		textDecoration:'underscore',
		fontFamily:'Roboto',
		lineHeight: '27px',
		textAlign:'center',
		fontSize: 10,
		marginLeft:'1.65%'

	},
	inputLabelBig:{
		flex:5,
		lineHeight: '27px',
		fontFamily:'Roboto',
		textDecoration:'underscore',
		textAlign:'center',
		fontSize: 10,
		marginLeft:'1.65%'

	},
	inputLabelBigger:{
		flex:7,
		lineHeight: '27px',
		fontFamily:'Roboto',
		textDecoration:'underscore',
		textAlign:'center',
		fontSize: 10,
		marginLeft:'1.65%'

	},
	inputWide:{
		fontFamily:'Roboto',
		flex:2,
		width:'auto',
		fontSize: 10,
	    height:'30px',
		marginTop: '0.7%',
	},
	inputWider:{
		fontFamily:'Roboto',
		flex:4,
		width:'auto',
		fontSize: 10,
	    height:'30px',
		marginTop: '0.7%',
	},
	actions:{
		display: 'flex',
	    flexDirection: 'row wrap',
		paddingLeft:20,
		paddingRight:20,
		// paddingTop:20
		fontSize: 10,
	},
	action:{
		flex:1,
		textAlign:'center',

	},
	buttonAdd:{
		width:120,
		height:120,
		padding:30
	},
	iconAdd:{
		width:60,
		height:60
	},
	inputPercent:{
		flex:1,
		// margin:10,
		fontSize: 10,
		fontFamily:'Roboto',
		textAlign:'left',
		marginTop: '1.65%',
	},
	toggleArea:{
		backgroundColor:'orange',
	},
	toggle:{
		marginRight:5,
		marginTop:'1.25%',
		textAlign:'left',

		flex:1,
	    // width:'auto',

	},
	thumbSwitched:{
		backgroundColor: '#0e8c00',
	},
	trackSwitched:{
		backgroundColor: '#90ff84',
	},

	cardTitle:{
		//fontSize: 14
	},
	summaryArea:{
		flex:2,
		paddingTop:'1.4%',
		minWidth:'165px',
		maxWidth:'165px',
		color:'#3D404A',
		fontWeight:'normal',
	},
	cardTitleInner:{

		fontSize: 13,
		flex:1,
		color:'#54a815',
	},
	cardsHeader:{
		fontFamily:'Roboto',
		height:48,
		fontWeight: 'bold',
		fontFamily: 'sans-serif',
		fontSize: 13,
		display:'flex',
	},
	addScreenerBtn:{
		fontSize:"15px",
		// fontWeight: 'bold',
		minWidth:"140px",
		fontFamily: 'sans-serif',
		marginTop:10,
		marginLeft:10,
	},
	addStrategyBtn:{
		fontSize:20,
		// fontWeight: 'bold',
		fontFamily: 'sans-serif',
		marginTop:10,
		marginLeft:10
	},
	addStrategyLink:{
		color:"#00a7f3",
		fontSize: "15px"
	},
	separator:{
	    // height: 48,
	    display: "-webkit-inline-box",
	    border: "solid 1px rgba(0, 0, 0, 0.541176)",
	    marginRight: '3.8%'
	},
	lastSeparator:{
	    // height: 48,
	    display: "-webkit-inline-box",
	    border: "solid 1px rgba(0, 0, 0, 0.541176)",
	    marginRight: 50,
	    position:'absolute',
	    top:0,
	    height:'100%',
	    right:2
	},
	equityArea:{
		flex:7,
		paddingTop:'0.7%',
		paddingBottom:'0.7%',
		paddingRight:10,
		color: "rgba(0, 0, 0, 0.541176)",
		minWidth:'490px',
		display:'flex',
	},
	equityAreaSub:{
		width:150,
		border:'1px solid #EAEAEA',
		display:'flex',
		marginRight:'10%',

	},
	ulTextGray:{
		lineHeight:'30px',
		marginRight:'7px',
		paddingBottom:'4px',
		fontFamily:'Roboto',
		color:'#3D404A',
		backgroundColor:'#EAEAEA',
		width:'40%',
		paddingLeft:'5%',
		fontWeight:'normal',

	},
	ulTextDark:{
		// borderBottom:"solid 1px black",
		// marginRight:'70px',
		fontWeight:'normal',
		lineHeight:'30px',
		// width:150,
		paddingBottom:'4px',
		color:'#363636',
		fontFamily:'Roboto',
	},
	symbolCountArea:{
		display: "inline-block",
		lineHeight:"normal",
		flex:3,
		paddingTop:'0.4%',
		textAlign:'center',
		maxWidth:'170px',
		marginRight:'80px',
		number:{
			fontSize: "28px",
			fontWeight:600,
			color:"rgba(0, 0, 0, 0.541176)",
			lineHeight:'40px',
		},
		text:{
			display:"inline-block",
			fontSize:"9px",
			margin:"8px",
			gray:{
			},
			dark:{

			}
		}
	},
	lowerButtons:{
		margin: 12,
		flex: 1,
	    lineHeight: '31px',
	    height: 35,
	    borderStyle:'solid',
	    borderWidth:1,
		minWidth:140,
	    // borderColor:'#5C5F67',
	    borderRadius:3,
	    margin:5,
	    paddingRight:3,
	    paddingLeft:3,
	    blue:{
	    	color:'rgb(0, 167, 243)',
	    },
	    green:{
	    	color:'rgb(84, 168, 21)',
	    },
	},
	addIcon:{
		lineHeight:'20px',
		verticalAlign:'middle',
	},

}

export default class SectorCard extends React.Component {

	constructor(props) {
		super(props);
		// console.log("Sector card CTOR", props)
		let s = toJS(props.sector.screeners)
		this.state = {
			expanded: false,
			needSave: false,
			etf:props.sector.etf,
			positionPrice:props.sector.positionPrice,
			stopLoss:props.sector.stopLoss,
			isTrailing:props.sector.isTrailing,
			targetPercentage:props.sector.targetPercentage,
			targetAmount:props.sector.targetAmount,
			size:props.sector.size,
			name:props.sector.name,
			screeners:s,
			strategies:props.sector.strategies,
			afterScreen:"N/A",
			errors: {
				etf:props.sector.etfError,
				positionPrice:props.sector.positionPriceError,
				stopLoss:props.sector.stopLossError,
				targetPercentage:props.sector.targetPercentageError,
				targetAmount: props.sector.targetAmountError,
				size:props.sector.sizeError
			}

		};
		this.countSymbols();
		this.inputTimeout = false
		// console.log('--------- screeners ----------')
		// console.log(props.sector.screeners)
	}



	handleExpandChange = (expanded) => {
	    this.setState({expanded: expanded});
	};

	handleToggle = (event, toggle) => {
		this.setState({expanded: toggle});
	};

	handleExpand = () => {
	this.setState({expanded: true});
	};

	handleReduce = () => {
	this.setState({expanded: false});
	};

	saveSector = () => {
		//
		if(this.inputTimeout){
			clearTimeout( this.inputTimeout );
		}
		let self = this
		this.inputTimeout = setTimeout( function(){
			self.props.save(self.props.sector)
			console.log("input timer")
		}, 500 );
	};

	onChange = (event) => {

		const e = event;
		// if(e.target.value && isNumeric(e.target.value) ){
		// 	// console.log(e.target.value)
		// 	return
		// }

		// e.preventDefault();
		// var state = this.state;
		// state[e.target.id] = e.target.value;
		this.props.sector[e.target.id] = e.target.value;
		if(e.target.id == 'size'){
			this.props.sector['sizePercentage'] = e.target.value == "" ? "" : numeral( numberToPercentage(e.target.value,this.props.totalBudget) ).format('0.[00]');
		}else if(e.target.id == 'sizePercentage'){
			this.props.sector['size'] = e.target.value == "" ? "" : numeral( percentageToNumber(e.target.value,this.props.totalBudget) ).format('0.[00]');
		}
		this.forceUpdate()
		// console.log(state);

		// this.setState(state)
		// console.log(this.state)


		this.saveSector()
		// this.inputTimeout = setTimeout( function(){self.saveSector()}, 1000 );


		// console.log(e.target.value);
		// console.log(e.target.id);
	};
	toggleTrailing = () => {
		//var newTrailing = !this.state.isTrailing;
		this.props.sector.isTrailing = !this.props.sector.isTrailing
		this.forceUpdate()
		// this.setState({isTrailing:newTrailing, needSave: true});
		// this.props.save(this.state);

		console.log("toggleTrailing");
	};

	// strategy functions
	addStrategy = () => {
		console.log("add strat")
		var strategy = {field:"8", name:'Short on Sector', vts:0, svts:0};
		// var currentStrategies = this.state.strategies;

		this.props.sector.strategies.push(strategy)
		this.forceUpdate()
		this.saveSector()
		// currentStrategies.push(strategy);
		// this.setState({strategies:currentStrategies, needSave: true});
		// this.props.save(this.state);
	};
	updateStrategyData = (strategy,index) => {
		// console.log("update strat")
		var strategies = this.state.strategies
		strategies[index] = strategies
		this.setState({needSave:true, strategies:strategies})
		// this.props.save(this.state);
	};
	duplicateStrategy = (strategy) => {
		console.log("dup strat")
		this.props.duplicateStrategy(strategy, this.state.name);
	};
	removeStrategy = (strategy) => {

		this.props.sector.strategies.remove(strategy)//(indexToSplice, 1)
		this.forceUpdate()
		this.saveSector()
		// this.props.save(this.state);
	};


	addScreener = () => {

		var screener = {field:'', name:'', minVal:"", maxVal:"", val_type:'', pos_type:2};
		// var currentScreeners = this.state.screeners;

		this.props.sector.screeners.push(screener)
		this.forceUpdate();
		// currentScreeners.push(screener);
		// this.setState({screeners:currentScreeners, needSave: true});
		// this.props.save(this.state);

	};



	updateScreenerData = (screener, index) =>{

		var screeners = this.state.screeners;
		screeners[index] = screener;

		this.setState({needSave:true, screeners:screeners});
		// this.props.save(this.state);

	};

	removeScreener = (screener) => {

		// console.log("removing screener ",screener)

		this.props.sector.screeners.remove(screener)//(indexToSplice, 1)
		this.forceUpdate()
		this.countSymbols();
	};
	duplicateScreener = (screener) =>{

		this.props.duplicateScreener(screener, this.state.name);

	};

	save = () => {
		this.setState({needSave:false});
		// this.props.save(this.state);
	};

	applyScreeners = debounce((sectorId)=>{
		//console.log("-----apply screeners",sectorName)
		let sectorCard = this;
		if( ((typeof this.props.sector.screeners === "undefined")|| (this.props.sector.screeners === null)) ){
			return;
		}
		let fScreeners = BuildStore.formatScreeners(this.props.sector.screeners);
			//console.log(fScreeners);

		BuildApi.checkScreeners(sectorId, fScreeners).then(function(res){
			// console.log(sector);
			sectorCard.setState({afterScreen:res.count});
		});
	});

	countSymbols = ()=>{
			this.applyScreeners(this.props.sector.sectorRefId);
	};

	screenersChanged = (nextScreeners, currentScreeners) => {

		if(nextScreeners.length != currentScreeners.length){
			return true;
		}
		var changed = false;
		forOwn(currentScreeners, function(screener, key){

			// console.log(screener, key, nextScreeners[key]);

			// console.log("\n")

			forOwn(screener, function(value, fieldName){
				if(screener[fieldName] != nextScreeners[key][fieldName]){
					changed = true;
				}
			})
		})
		return changed;
	}
	componentWillUpdate = (nextProps, nextState) => {
		// console.log('componentWillUpdate', nextProps.sector.screeners ,(this.props.sector.screeners !== nextProps.sector.screeners), this.props);

		var sectorCard = this;

		if(this.props !== nextProps){

			// // console.log("inside")


			if(nextProps.sector && this.props.sector && this.state.screeners){

				if(sectorCard.screenersChanged(toJS(nextProps.sector.screeners), sectorCard.state.screeners)){
					sectorCard.applyScreeners(nextProps.sector.sectorRefId);
				}
			}


			this.setState({
					needSave: false,
					etf:nextProps.sector.etf,
					positionPrice:nextProps.sector.positionPrice,
					stopLoss:nextProps.sector.stopLoss,
					posNum:nextProps.sector.posNum,
					isTrailing:nextProps.sector.isTrailing,
					targetPercentage:nextProps.sector.targetPercentage,
					targetAmount:nextProps.sector.targetAmount,
					size:nextProps.sector.size,
					name:nextProps.sector.name,
					screeners:toJS(nextProps.sector.screeners),
					strategies:nextProps.sector.strategies,

					errors: {
						etf:nextProps.sector.etfError,
						positionPrice:nextProps.sector.positionPriceError,
						stopLoss:nextProps.sector.stopLossError,
						targetPercentage:nextProps.sector.targetPercentageError,
						targetAmount: nextProps.sector.targetAmountError,
						size:nextProps.sector.sizeError
					}
				});

			//
		}
	};


   	render() {
   		let closeIconNode = <ImageNavigateNext/>
   		let openIconNode = <HardwareKeyboardArrowDown/>
   		var startegyToolBars
   		var screenerToolBars
   		if(this.props.sector.strategies)
	   		var startegyToolBars = this.props.sector.strategies.map(function(strategy, index){

	   			return (<StrategyToolBar saveStrategy={this.saveSector} strategies={this.props.sector.strategies} strategy={strategy} id={index} key={index} update={this.updateStrategyData} removeSimilerStrategies={this.props.removeSimilerStrategies} duplicateStrategy={this.duplicateStrategy} delete={this.removeStrategy}/>);
	   		}.bind(this));
   		if(this.props.sector.screeners)
	   		var screenerToolBars = this.props.sector.screeners.map(function(screener, index){

	   			return (<ScreenerToolBar screeners={this.props.sector.screeners} screener={screener} id={index} key={index} update={this.updateScreenerData} removeSimilerScreeners={this.props.removeSimilerScreeners} duplicateScreener={this.duplicateScreener} delete={this.removeScreener} count={this.countSymbols}/>);
	   		}.bind(this));
	   	// console.log("stlength",startegyToolBars.length)
	   	// var headerChildren = function (){
	   	// 	return ();
	   	// }
	    return (
        <div className="sector-card" style={this.props.style}>
	      	<Card className={this.props.sector.selected ? '' : 'hidden'} style={styles.SectorCard} expanded={this.state.expanded} onExpandChange={this.handleExpandChange}>
		        {
	        	<CardHeader
	        	  style={styles.cardsHeader}
	        	  titleStyle={styles.cardTitleInner}
	        	  title={this.props.sector.name}
	        	  closeIcon={closeIconNode}
	        	  openIcon={openIconNode}
	        	  // subtitle={numeral(this.props.sector.size).format('0,0.[00]')+'$'+' ('+numeral(this.props.sector.size/(this.props.totalBudget/100)).format('0.[00]')+'%)'}
	        	  actAsExpander={true}
	        	  showExpandableButton={true}
	        	  className="card-header">
					<div style={styles.summaryArea}>
						{numeral(this.props.sector.size).format('0,0.[00]')+' $'+' ('+numeral(this.props.sector.size/(this.props.totalBudget/100)).format('0.[00]')+'%)'}
		        	</div>
		        	<div style={styles.separator}></div>
		        	<div style={styles.equityArea}>
		        		<div style={styles.equityAreaSub}>
		        			<div style={styles.ulTextGray}>Equity</div>
		        			<div style={styles.ulTextDark}>{numeral(this.props.sector.sectorEquity).format('0,0.[00]')+' $'}</div>
		        		</div>
		        		<div style={styles.equityAreaSub}>
			        		<div style={styles.ulTextGray}>Cash</div>
			        		<div style={styles.ulTextDark}>{numeral( parseFloat(this.props.sector.size) + parseFloat(this.props.sector.sectorValue) ).format('0,0.[00]')+' $'}</div>
						</div>
		        	</div>


	        		<div style={styles.separator}></div>
	        		<div style={styles.symbolCountArea}>
	        			<span style={styles.symbolCountArea.number}>{this.state.afterScreen}</span>

	        			<span style={styles.symbolCountArea.text}>
	        				<span style={styles.symbolCountArea.text.gray}>Matching Stocks </span>
	        				<br/>
	        				<span style={styles.symbolCountArea.text.dark}>{(this.props.sector.screeners.length > 0)? "(screeners applied)" : ""}</span>
	        			</span>
	        		</div>
	        		<div style={styles.lastSeparator}></div>
				</CardHeader>
		        }

		        {
			        <CardText style={{backgroundColor:'rgb(224, 224, 224', paddingTop:5}} expandable={true}>

				      	<div className={this.props.sector.selected&&this.state.expanded ? '' : 'hidden'}>
				      		<div className={this.state.expanded ? '' : 'hidden'} style={styles.addScreenerBtn}>
				      			<FlatButton style={{...styles.lowerButtons, ...styles.lowerButtons.green}} onClick={this.addScreener}>
				      				<FontIcon style={{...styles.addIcon, ...styles.lowerButtons.green}} className="icon-add"/> Add screener
				      			</FlatButton>
				      			<FlatButton style={{...styles.lowerButtons, ...styles.lowerButtons.blue}} onClick={this.addStrategy}>
				      				<FontIcon style={{...styles.addIcon, ...styles.lowerButtons.blue}} className="icon-add"/> Add strategy
				      			</FlatButton>
				      		</div>
					      	<div className={this.state.expanded ? '' : 'hidden'} >
					      		{startegyToolBars}
				      		</div>
					      	<div className={this.state.expanded ? '' : 'hidden'} >
					      		{screenerToolBars}
				      		</div>

			      		</div>
			        </CardText>
		    }

	      	</Card>

	    </div>
	    );
  }

}
// TODO MOVE TO SOME UTILS??
// http://davidwalsh.name/javascript-debounce-function
// function debounce(func, wait, immediate) {
// 	// console.log("%%%%%%%%%%%%% DEBOUNCE")
// 	var timeout;
// 	return function() {
// 		var context = this, args = arguments;
// 		var later = function() {
// 			timeout = null;
// 			if (!immediate) func.apply(context, args);
// 		};
// 		var callNow = immediate && !timeout;
// 		clearTimeout(timeout);
// 		timeout = setTimeout(later, wait);
// 		if (callNow) func.apply(context, args);
// 	};
// };



// WEBPACK FOOTER //
// ./src/js/components/SectorCard.js